module.exports = __webpack_public_path__ + "img/daipingjia.0859b4a6.png";